import {useLocation} from "react-router";
import {useState,useEffect,useCallback,useMemo} from "react";
import useRequestController from "./useRequestController.js";
import {enqueueSnackbar} from "notistack";
import moment from "moment";

const baseSortModel= [{}]


export function getRowsFromObject(row,filters){
    return {
        ...row
    }
}
export const EXCLUDE_SELECTED = 'exclude_selected_in_filters';

export function createFiltersQueryString(filters) {
    let searchFilters = new URLSearchParams();
    Object.entries(filters).forEach(([key,val])=>{
        switch (true) {
            case Array.isArray(val):
                val.forEach(el=>searchFilters.append(key,el));
                break;
            case typeof val ==="boolean":
                searchFilters.append(key,val?1:0);
                break;
            case( moment.isMoment(val) && val.isValid() ) :
                searchFilters.append(key,val.format('YYYY-MM-DD'));
                break;
            default:
                searchFilters.append(key,val);
                break;
        }
    });
    return '?'+ searchFilters.toString();
}

function toRequv(name,symbol='.') {
    //function to get column name for filtering table
    // if column name include . symbol its mean that column from other table
    if(name.includes(symbol)){
        const str = name.split(symbol)
        return `${str[0]}[${str[1]}]`
    }
    return name
}

export const basicTableLoadingState = {loadServer:true,loadDelete:false,preloadData:false};

export default function useTablePagination(
    columnModel,
    generateTableRow=getRowsFromObject,
    filterModel,
    getData,
    listFieldOptions,
    tableFieldsMap={},
    initialTableLoadingState=basicTableLoadingState,
    onFiltersApply=()=>{},
    initialSortModel=baseSortModel,
    sendInitialFilters,
){
    const location = useLocation();
    const [sortField,setSortField] = useState(initialSortModel[0].field);
    const [sortOrder,setSortOrder] = useState(initialSortModel[0].sort);
    const [paginationModel,setPaginationModel] = useState({
        page: 0,
        pageSize: 50
    });
    const [data,setData] = useState([]);
    const [rows, setRows] = useState([]);
    const [rowCount,setRowCount]= useState(0);
    const [tableLoading,toggleTableLoading] = useState(initialTableLoadingState);
    const [filterParams,setFilterParams] = useState(getFilters(
        !location.search && sendInitialFilters
            ?createFiltersQueryString(sendInitialFilters)
            :location.search
        ,filterModel,onFiltersApply));
    const [isFirst,setIsFirst]= useState(true);
    const [meta,setMeta] = useState({});
    const [columns,setColumns] = useState([]);
    const requestController = useRequestController();

    function getTable(){
        const parsedModel = sortField && sortOrder && [tableFieldsMap.hasOwnProperty(sortField)
            ?tableFieldsMap[sortField]
            :sortField
            ,sortOrder];
        const current = requestController.new();
        // request for data Page from server
        toggleTableLoading(val=>({...val,loadServer:true}));
        return getData(`?per_page=${paginationModel.pageSize}&page=${+paginationModel.page+1}${filterParams?'&'+filterParams:''}${parsedModel?`&sort_by=${toRequv(parsedModel[0])}&sort_dir=${parsedModel[1]}`:''}`)
            .then(response=>{
                const table = response.data;
                if(requestController.isLast(current)){
                    setRowCount(table.meta.total);
                    setData(table.data);
                    setMeta(table.meta);
                }
                return table
            })
            .catch(e=>{
                console.log(e)
                if(e.response?.data?.message){
                    enqueueSnackbar(e.response?.data?.message,{variant:'error'})
                }
            })
            .finally((response)=>{

                toggleTableLoading(val=>({...val,loadServer:false}));
                return response
            })
    }

    const onPaginationModelChange = useCallback(({pageSize, page})=> {
        //if page size change discard current page number to first page
        setPaginationModel({pageSize, page})
    },[]);

    const onSortModelChange  = useCallback((sortModel)=> {

        setSortField(sortModel[0]?sortModel[0].field:'');
        setSortOrder(sortModel[0]?sortModel[0].sort:'');
    },[]);

    useEffect(() => {
        //get new Page if filters,page Number or Page Size change
        if(isFirst){
            toggleTableLoading(val=>({...val,preloadData:true}));
            getTable()
                .then((response)=>{
                    setIsFirst(false);
                    toggleTableLoading(val=>({...val,preloadData:false}));
                    // create columns
                    setColumns(columnModel)
                    // NO Column restrictions yet
                    // setColumns(columnModel.filter(column=>response.meta.columns.includes(column.field)));
                })
            toggleTableLoading(val=>({...val,loadServer:false}));
        }else {

            getTable()
        }
    }, [paginationModel,filterParams,sortField,sortOrder]);

    useEffect(()=>{
        //get names from filters based on ids from data
        setRows(rows=>{
            if(!Array.isArray(rows)){
                return []
            }
            return data.map(row=>generateTableRow(row,listFieldOptions))
        });
    },[data, listFieldOptions ]);

    useEffect(()=>{
        if(!location.search && sendInitialFilters){
            setFilterParams(  getFilters(
                createFiltersQueryString(sendInitialFilters),
                filterModel,
                onFiltersApply,
                ()=> {

                })
            )
        }else {
            setFilterParams(  getFilters(
                location.search,
                filterModel,
                onFiltersApply,
                ()=>{

                }))
        }
    },[location.search]);


    const memoDataGridOptions = useMemo(
        ()=>{
            return {
                columns,
                rows,
                paginationModel,
                rowCount,
                sortModel:sortOrder&&sortField?[{sort:sortOrder,field:sortField}]:[],
                pagination:true,
                paginationMode:"server",
                sortingMode:"server",
                // filterMode:"server",
                // disableColumnFilter:true,
                onSortModelChange,
                rowsPerPageOptions:[25,50,100],
                onPaginationModelChange,
                loading:Object.values(tableLoading).some(v=>v),
            }
        },[rows,paginationModel,rowCount,columns,tableLoading]);
    return {
        dataGridOptions:memoDataGridOptions,
        location,
        getTable,
        setData,
        filterParams,
        meta,
        tableLoading,
        toggleTableLoading,
    }
}

export function getFilters(search,filterModel,onFiltersApply,onSuccess=()=>{}) {
    //if filters change
    //parse filters to query prams
    // discard page to first and send new request
    try {
        const filtersSearch = new URLSearchParams(search);
        const queryParams = new URLSearchParams();
        const filters = {};
        let excludeSelected = filtersSearch.has(EXCLUDE_SELECTED)
            ? filtersSearch.getAll(EXCLUDE_SELECTED)
            : [];
        if(!Array.isArray(excludeSelected)){
            excludeSelected = [];
        }
        Object.entries(filterModel).forEach(([key,val])=>{
            if(key === 'in'){
                val.forEach((name)=>{
                    if(filtersSearch.has(name)){
                        filters[name] =  filtersSearch.getAll(name)
                    }
                });
            }else if(key === 'date'){
                val.forEach((name)=>{
                    if(filtersSearch.has(name)){
                        filters[name] =  moment(filtersSearch.get(name),'YYYY-MM-DD',true);
                    }
                });
            }else if(key === 'custom'){
                Object.entries(val).forEach(([name,val]) => {
                    if(filtersSearch.has(name)){
                        val.getter(filters,filtersSearch);
                    }
                });
            }else {
                val.forEach((name)=>{
                    if(filtersSearch.has(name)){
                        filters[name] = filtersSearch.get(name);
                    }
                });
            }
        });
        onFiltersApply(filters);
        filters && Object.entries(filters).forEach(([key,val])=>{
            Object.entries(filterModel).forEach(([filterKey,filterModel])=>{
                if( ( Array.isArray(filterModel) && filterModel.includes(key) )
                    || filterModel.hasOwnProperty(key)
                ){
                    filtersMethods[filterKey](queryParams,key,val,filterModel,excludeSelected);
                }
            });
        });
        onSuccess(queryParams.toString());
        return queryParams.toString();
    }
    catch (e) {
        console.log(e);
        return '';
    }
}

const filtersMethods = {
    'in':(queryParams,key,val,filterModel,excludeSelected)=>{
        if(val && val.length){
            queryParams.append(
                (excludeSelected.includes(key) ? "filter_not_in_" : "filter_in_") +toRequv(key),val.toString()
            )
        }
    },
    'str_in':(queryParams,key,val)=>{
        if(val && val.length){
            queryParams.append("filter_in_"+toRequv(key),val.toString().trim().replaceAll(/\s+/g,','))
        }
    },
    'where':(queryParams,key,val)=>{
        if(val ||val===0){
            queryParams.append("filter_where_"+toRequv(key),val);
        }
    },
    'like':(queryParams,key,val)=>{
        if(val ||val===0 ){
            queryParams.append("filter_like_"+toRequv(key),val);
        }
    },
    'date':(queryParams,key,val)=>{
        if(moment.isMoment(val) && val.isValid()){
            queryParams.append("filter_"+toRequv(key),moment(val).format('YYYY-MM-DD'));
        }
    },
    'lt':(queryParams,key,val)=>{
        if(val ||val===0){
            queryParams.append("filter_lt_"+toRequv(key),val)
        }
    },
    'gt':(queryParams,key,val)=>{
        if(val ||val===0){
            queryParams.append("filter_gt_"+toRequv(key),val)
        }
    },
    'custom':(queryParams,key,val,filterModel)=>{
        filterModel[key].setter(queryParams,key,val)
    },
};